import React, { useState, useEffect } from 'react';

const ImageLoader = ({ src, alt, className, placeholder = 'bg-gray-200' }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  
  useEffect(() => {
    const image = new Image();
    image.src = src;
    image.onload = () => setIsLoaded(true);
    
    return () => {
      image.onload = null;
    };
  }, [src]);
  
  return (
    <div className={`relative ${className}`}>
      {!isLoaded && (
        <div className={`absolute inset-0 animate-pulse ${placeholder}`} />
      )}
      <img
        src={src}
        alt={alt}
        className={`w-full h-full object-cover transition-opacity duration-500 ${
          isLoaded ? 'opacity-100' : 'opacity-0'
        }`}
      />
    </div>
  );
};

export default ImageLoader;